import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router>
        <App />
      </Router>
    </AuthProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Solo disparamos el evento si hay un worker esperando y no hemos avisado ya
    if (registration.waiting && !sessionStorage.getItem('pwa_update_prompted')) {
      window.dispatchEvent(new CustomEvent("pwa-update-available", { detail: registration }));
      sessionStorage.setItem('pwa_update_prompted', 'true');
    }
  },
});
